import Vue from 'vue'
import VueRouter from 'vue-router'
import NewIndex from '../views/New/Index'
import ChooseSubject from '../views/New/ChooseSubject'
import ChoosePreset from '../views/New/ChoosePreset'
import CreateActivity from '../views/New/CreateActivity'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: NewIndex,
    children: [
      {
        path: '',
        name: 'new-subject',
        component: ChooseSubject
      },
      {
        path: 'create/subject/:subjectId',
        name: 'new-preset',
        component: ChoosePreset
      },
      {
        path: 'create/preset/:presetId',
        name: 'new-preset-activity',
        component: CreateActivity
      },
      {
        path: 'custom/subject/:subjectId',
        name: 'new-custom-activity',
        component: CreateActivity
      }
    ]
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import(/* webpackChunkName: "settings" */ '../views/Settings/Index'),
    redirect: 'settings-presets',
    children: [
      {
        path: '/settings/subjects',
        name: 'settings-subjects',
        component: () => import(/* webpackChunkName: "settings" */ '../views/Settings/Subjects'),
        meta: {
          title: 'Subjects'
        }
      },
      {
        path: '/settings/presets',
        name: 'settings-presets',
        component: () => import(/* webpackChunkName: "settings" */ '../views/Settings/Presets'),
        meta: {
          title: 'Presets'
        }
      },
      {
        path: '/settings/students',
        name: 'settings-students',
        component: () => import(/* webpackChunkName: "settings" */ '../views/Settings/Students'),
        meta: {
          title: 'Students'
        }
      }
    ]
  },
  {
    path: '/reports',
    name: 'reports',
    component: () => import(/* webpackChunkName: "reports" */ '../views/Report')
  },
  {
    path: '*',
    name: 'not-found',
    component: () => import(/* webpackChunkName: "notfound" */ '../views/NotFound')
  }

]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
